import styled from 'styled-components'

export const SectionContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`

export const TooltipDivider = styled.hr`
  margin: 8px 0;
  border: none;
  border-top: 1px solid rgba(255, 255, 255, 0.3);
`

export const Sub = styled.sub`
  font-size: 1em;
`

export const Sup = styled.sup`
  font-size: 1em;
`

export const LABEL_WIDTH = '30%'
